<div class="modal-header">
  <h4 class="modal-title">
    {{'projectRequestPopup.title.assembly_not_immediately_possible' | translate}}
  </h4>
  <button type="button" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{'projectRequestPopup.message.assembly_not_immediately_possible' | translate}}</p>
    <p class="font-weight-bold text-center">{{'assemblyDelayPopup.label.articleList' | translate}}</p>
    <div class="fixed-fluid flex-grow-1">
      <div class="fluid d-flex flex-column overflow-scrolling-touch">
        <table class="table table-striped table-hover flex-grow-0 flex-shrink-0" fixedHeader [virtual]="true">
          <thead>
            <tr class="d-flex w-100">
              <th class="d-block flex-shrink-1 flex-grow-1 table-sort" [class.desc]="isSortDescending" (click)="sort()" #headerArticleNumber>{{'assemblyDelayPopup.label.articleNumber' | translate}}</th>
            </tr>
          </thead>
        </table>
        <virtual-scroller #scroll class="flex-grow-1 overflow-xh scroll-maxh-300" [items]="unavailableArticles" [enableUnequalChildrenSizes]="true"
          maxHeightOffset="700">
          <table class="accessory-table table table-hover table-striped table-overflow-hidden fixed-layout">
            <tbody class="new-stacking-context" #container>
              <tr *ngFor="let article of unavailableArticles">
                <td [attr.width.px]="headerArticleNumber.clientWidth">
                  {{article.articleNo}}
                </td>
              </tr>
            </tbody>
          </table>
        </virtual-scroller>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close(false)">{{'global.label.cancel' | translate}}</button>
  <button type="submit" class="btn btn-primary btn-forward" (click)="close(true)">{{'global.label.step_forward' | translate}}</button>
</div>
